/*
It is not possible to call plans API everywhrere at the moment
because price groups.
If you need to access plans on the client be sure to import this file.
*/
import events from "@/events";
import store from "@/store/";

events.on("abtest:ready", () => {
  store.dispatch("plans/load");
});
